export const MODULE_NAME = 'template'

export const STORE_ID = MODULE_NAME
